// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"be26c831","84":"010f4a37","279":"b548f0c3","346":"55064497","692":"da0095f8","807":"a0507967","821":"a4a9dc96"}[chunkId] + ".chunk.js";
};